export default {
  NAME: 'vest-frontend',
  WALLET_CONNECT_PROJECT_ID: '1a65d8e86c5954eae3897a2bd8cdbe30',
  QUIKNODE_MAINNET_RPC_ENDPOINT: `https://dark-dark-snowflake.solana-mainnet.quiknode.pro/38ca3d63cd0b02768fe7f8ca6b649319901ba5d9`,
};
